<template>
  <ModalContainer :show="show">
    <template slot="body">
      <div class="modal-content">
        <div class="d-flex align-items-center justify-content-end">
          <img
            src="../../assets/images/Vector (1).png"
            alt="close"
            class="cursor-pointer mt-1 mr-1"
            @click="$emit('close')"
          />
        </div>

        <div
          class="d-flex flex-column align-items-center justify-contents-center body"
        >
          <IconWarningYellow v-if="isYellow" />
          <IconWarningBrandBlue v-else />

          <p class="mt-3 font-20 font-weight-bolder">{{ heading }}</p>

          <p class="gray4 font-14 text-center" :class="msgWidth">
            <span v-if="additionalMessage">
              <span> {{ this.$t("confrim_txt") }} </span>
              <span style="font-weight: 600; color: rgba(94, 106, 121, 1)">
                {{ insurancePlan.amount }}
              </span>
              <span> {{ this.$t("for-txt") }} </span>
              <span style="font-weight: 600; color: rgba(94, 106, 121, 1)">
                {{ insurancePlan.plan }}
              </span>
              <span> {{ this.$t("confrim-txt") }} </span>
            </span>

            <span v-else> {{ msg }} </span>
          </p>

          <div
            class="mt-4 d-flex justify-contents-between align-items-center col-gap-2 w-100"
          >
            <button
              type="button"
              class="btn btn-secondary w-100"
              @click="$emit('close')"
              v-if="showSecondaryBtn"
            >
              {{ isYellow ? $t("no") : $t("cancel") }}
            </button>

            <button
              type="button"
              class="btn btn-primary w-100"
              @click="$emit('submit')"
            >
              {{ btnTxt }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </ModalContainer>
</template>

<script>
import IconWarningBrandBlue from "../../components/Iconsvg/IconWarningBrandBlue.vue";
import IconWarningYellow from "../../components/Iconsvg/IconWarningYellow.vue";
import ModalContainer from "../../components/ModalContainer";

export default {
  name: "ConfirmModal",
  data() {
    return {
      vesselNames: [],
    };
  },
  components: {
    ModalContainer,
    IconWarningBrandBlue,
    IconWarningYellow,
  },
  props: {
    show: Boolean,
    heading: String,
    msg: String,
    btnTxt: String,
    isYellow: Boolean,
    msgWidth: {
      type: String,
      default: "msg_default",
    },
    showSecondaryBtn: {
      type: Boolean,
      default: true,
    },
    insurancePlan: Object,
    additionalMessage: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 100%;
}
.body {
  padding: 50px;
}
@media (max-width: 575.98px) {
  .modal-content {
    width: 100% !important;
  }
  .body {
    padding: 25px;
  }
}
</style>
